import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=dda0bc42&"
import script from "./ContactCard.vue?vue&type=script&lang=js&"
export * from "./ContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports